import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import IconButton from "../components/IconButton";
import { NavigationContext, UserContext } from "../contexts";
import { getPageTitle } from "../resources/routes";
import { IconName, LandType, RoutePath } from "../types";
import { scrollToTop } from "../util";

const HomeScreen = observer(() => {
  const [selectedOption, setSelectedOption] = useState<LandType | null>(null);
  const userContext = useContext(UserContext);
  const navContext = useContext(NavigationContext);
  const location = useLocation();

  useEffect(() => {
    navContext.resetNextBtn();
    navContext.setNextButtonVisible(false);
    navContext.setBackButtonVisible(false);
    navContext.setRestartButtonVisible(false);
    navContext.setSubtotalVisible(false);
    scrollToTop();
  }, []);

  useEffect(() => {
    navContext.setLoginButtonVisible(!userContext.isLoggedIn);
    navContext.setFooterNavVisible(
      !userContext.isLoggedIn || userContext.enteredViaRestoreSession
    );
  }, [userContext.isLoggedIn]);

  const onClickOption = (option: LandType) => {
    setSelectedOption(option);
    userContext.setLandType(option);
    if (option === LandType.HOUSE_LAND_PACKAGE) {
      navContext.goTo(RoutePath.PACKAGE_SEARCH);
    } else {
      navContext.goTo(navContext.getNextRoute(navContext.currentRoute));
    }
    scrollToTop();
  };

  return (
    <div className={"screen screen-home container"}>
      <h1>{getPageTitle(location.pathname)}</h1>
      <p className={"subtitle"}>
        Before we get started, click on which option best describes your current
        situation.
      </p>
      <div className={"land-types"}>
        <IconButton
          active={selectedOption === LandType.VACANT_BLOCK}
          icon={IconName.PLANT}
          size={"large"}
          highlightStyle={"underline"}
          title={"I'm looking to build on a vacant block"}
          onClick={() => onClickOption(LandType.VACANT_BLOCK)}
        />
        <IconButton
          active={selectedOption === LandType.KNOCK_DOWN_REBUILD}
          icon={IconName.KNOCK_DOWN_REBUILD}
          size={"large"}
          highlightStyle={"underline"}
          title={"I'm planning a knock down rebuild project"}
          onClick={() => onClickOption(LandType.KNOCK_DOWN_REBUILD)}
        />
      </div>
    </div>
  );
});

export default HomeScreen;
